import { Box, Button, Grid, IconButton, Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles, Theme, createStyles, useTheme } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react'
import { useAppSelector, useAppDispatch } from '../reduxhooks';
import { addItemCount, canAddProductAmountToCart, CartItemsWithCouponPromotionsDict, CheckIsPlusSize, GetBundlingKeyAmountDict, getDiscountedPriceAndTimestampInProductSpotlightList, postCanAddItemCount, removeItem, removeItemCount } from '../redux/CartRedux';
import { CartStateItem, ProductSpotlight, RegularSizeValue, SizeType } from 'common-ts/dist/models/Cart';
import Add from '@material-ui/icons/Add';
import Remove from '@material-ui/icons/Remove';
import { ProductsList } from 'common-ts/dist/models/Product';
import Close from '@material-ui/icons/Close';
import { Mixpanel } from '../mixpanel';
import ReactHtmlParser from 'react-html-parser';
import hash from 'object-hash';
import { updateCurrentScreen } from '../redux/UIOverlayNavbarRedux';
import { useHistory } from 'react-router-dom';
import Countdown from 'react-countdown';
import EditIcon from '@material-ui/icons/Edit';
import { countdownRendererImgFullwidth, countdownRendererNoText } from './ProductDetailShared';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import OverlayViewLabelNamaUpdate from './OverlayViewLabelNamaUpdate';
import { CalculateClothingMeasurementsFromBodyMeasurements, ClothingType, FitType, GetKey2CategoryClothingSizeMeasurementValues, RoundClothingMeasurementsToHalfPoint, GetChangedClothingMeasurementsFromBodyMeasurementsUpdate, UserBodyMeasurements, UserClothTypeSpecificBodyMeasurements } from 'common-ts/dist/models/UserMeasurements';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cartContentItem: {
      width: '100%',
      padding: '0px',
      marginTop: '10px',
    },
    cartContentImageGridItem: {
      [theme.breakpoints.down('xs')]: {
        display: 'flex',
        justifyContent: 'center',
      }
    },
    cartContentImageContainer: {
      minWidth: '100px',
      width: '100px',
      // height: '100px',
      overflow: 'hidden',
      marginLeft: '2px',
      marginRight: '24px',
      [theme.breakpoints.down('xs')]: {
        minWidth: '90px',
        width: '90px',
        // height: '90px',
        marginLeft: '0px',
        marginRight: '0px',
      }
    },
    cartContentImage: {
      width: '100%',
    },
    cartItemDetails: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: 'auto',
      paddingLeft: '20px',
      [theme.breakpoints.down('xs')]: {
        paddingLeft: '16px',
      },
    },
    cartContentItemName: {
      display: 'block',
      textAlign: 'left',
      marginBottom: '10px',
    },
    cartContentItemNameText: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      [theme.breakpoints.down('xs')]: {
        fontSize: '14px',
      }
    },
    cartContentItemSub: {
      display: 'block',
      textAlign: 'left',
      marginBottom: '14px',
    },
    cartContentItemSubText: {
      // textOverflow: 'ellipsis',
      // overflow: 'hidden',
      // whiteSpace: 'nowrap',
      fontSize: '14px',
      color: '#3e3e3e',
      [theme.breakpoints.down('xs')]: {
        fontSize: '12px',
      }
    },
    cartContentItemSubTextRed: {
      fontSize: '14px',
      color: 'red',
      [theme.breakpoints.down('xs')]: {
        fontSize: '12px',
      }
    },
    cartContentItemSubGantiUkuranText: {
      cursor: "pointer",
      fontSize: "10px",
      textWrap: "nowrap",
      fontWeight: 500,
      textDecoration: "underline #121212 solid 1px",
      textUnderlineOffset: "3px",
      paddingBottom: "2px",
    },
    cartContentItemAmount: {
      display: 'inline-block',
      width: '30px',
    },
    cartContentItemAmountText: {
      fontSize: '13px',
      fontFamily: 'Open Sans, sans-serif',
    },
    cartItemAmountButtonsContainer: {
      width: '90px',
      border: '2px solid rgb(211, 212, 213)',
      marginBottom: '6px',
    },
    cartItemAmountButton: {
      width: '30px',
      height: '30px',
    },
    removeAndPriceContainer: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      display: 'flex',
      alignItems: 'flex-end',
    },
    removeItemButton: {
    },
    itemPrice: {
      fontFamily: 'Open Sans, sans-serif',
      fontSize: '15px',
      paddingBottom: '6px',
      textAlign: 'right',
      [theme.breakpoints.down('xs')]: {
        fontSize: '12px',
      }
    },
    itemStrikePriceRed: {
      color: 'red',
      fontFamily: 'Open Sans, sans-serif',
      fontSize: '12px',
      paddingBottom: '6px',
      // marginRight: '6px',
      textDecoration: 'line-through',
      [theme.breakpoints.down('xs')]: {
        fontSize: '10px',
      }
    },
    itemStrikePrice: {
      fontFamily: 'Open Sans, sans-serif',
      fontSize: '12px',
      paddingBottom: '6px',
      // marginRight: '6px',
      textDecoration: 'line-through',
      [theme.breakpoints.down('xs')]: {
        fontSize: '10px',
      }
    },
    sizeOptionsBoxDetailText: {
      fontWeight: 500,
      letterSpacing: 0.5,
      paddingTop: '2px',
      fontSize: '2.1vw', // 9px -> 3px is 0.8vw
      [theme.breakpoints.up('sm')]: {
        fontSize: '9px',
        paddingTop: '2px',
      }
    },
    sizeOptionsBoxDetailIconButton: {
      border: '1px solid #232323',
      borderRadius: '30px',
      backgroundColor: '#232323',
      color: '#fefefe',
      padding: '1.2vw 2.4vw',
      [theme.breakpoints.up('sm')]: {
        padding: '5px 10px 5px 10px',
      }
    },
    sizeOptionsBoxEditIconButton: {
      border: '1px solid #232323',
      borderRadius: '40px',
      backgroundColor: '#232323',
      color: '#fefefe',
      padding: '1.5vw 1.5vw',
      [theme.breakpoints.up('sm')]: {
        padding: '5px 7px 5px 7px',
      }
    },
    editLabelContent: {
      border: '1px solid #cacaca',
      borderRadius: '16px',
      padding: '12px 17px',
      width: '100%',
      marginTop: '10px',
      letterSpacing: '0.1px',
    },
    labelHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 10,
    },
    timerBox: {
      border: '1px solid #7d7d7dff',
      borderRadius: '25px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      gap: 3,
      padding: 3,
      letterSpacing: '0.1px',
    },
    countdown: {
      backgroundColor: '#232323ff',
      fontSize: '10px',
      fontWeight: 500,
      color: '#fefefe',
      borderRadius: '10px',
      padding: '3px 7px .5px 7px',
    },
    keteranganTimer: {
      fontSize: '9px',
      paddingTop: 2,
      opacity: 0.8,
      marginRight: 3,
    },
    keteranganWaktuHabis: {
      fontSize: '9px',
      color: '#898989ff',
      textAlign: 'right',
    },
    gridLabelContainer: {
      marginTop: '5px',
      marginBottom: '5px',
      letterSpacing: '0.1px',
    },
    labelItem: {
      backgroundColor: '#232323',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '5px 10px',
    },
    labelName: {
      color: '#fefefe',
      fontWeight: 600,
      fontSize: '16px',
      marginTop: '3px',
      letterSpacing: '0.7px',
    },
  }),
);

const countdownRendererPromo = ({ hours, minutes, seconds, completed }: any) => {
  if (completed) {
    return (
    <div/>);
  } else {
    return (
    <Box style={{
      position: 'relative',
      display: 'flex',
    }}>
      <Typography style={{
        fontSize: '7px',
        fontFamily: 'OakesGrotesk',
        textAlign: 'left',
        paddingRight: '9px'
      }}>
        <b>SISA<br/>WAKTU</b>
      </Typography>
      <Typography style={{
        padding: '3px 7px 2px 7px',
        borderRadius: '10px',
        color: '#ffffff',
        backgroundColor: 'green',
        fontSize: '11px',
        fontFamily: 'OakesGrotesk',
        fontWeight: 500,
      }}>{String(hours).padStart(2, '0')}:{String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}</Typography>
    </Box>)
  }
}

export interface CartContentItemProps {
  cartItem: CartStateItem,
  productsList: ProductsList,
  isModifiable: boolean,
  cartItemsWithCouponPromotions: CartItemsWithCouponPromotionsDict,
  parentRenderCallback: (renderTime: string) => void,
  hideDiscountedPrice?: boolean
  showDetailEditButton?: boolean
  startIndex?: number
  labelNamaManualArray?: string[]
  setLabelNamaDialogOpen?: React.Dispatch<React.SetStateAction<boolean>>
  setSelectedLabelNama?: React.Dispatch<React.SetStateAction<null | number>>
  changeLabelNamaDeadline?: string
}

function CartContentItem({cartItem, productsList, isModifiable, cartItemsWithCouponPromotions, parentRenderCallback, hideDiscountedPrice, showDetailEditButton, startIndex, labelNamaManualArray, setLabelNamaDialogOpen, setSelectedLabelNama, changeLabelNamaDeadline}: CartContentItemProps) {
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const history = useHistory();

  const theme = useTheme();
  const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));

  const productDetail = productsList.productsDictionary[cartItem.productId];
  const userBodyMeasurementsDict = useAppSelector(state => state.userMeasurementsList.userBodyMeasurementsDictionary);
  const userClothingMeasurementsDict = useAppSelector(state => state.userMeasurementsList.userClothingMeasurementsDictionary);
  const userAccount = useAppSelector(state => state.account);
  const cart = useAppSelector(state => state.cart);

  const key2 = productDetail?.clothingType + "-" + cartItem.fitType;

  // edit label nama expired
  const [labelExpired, setLabelExpired] = useState(false);

  if (productDetail === undefined) {
    return null;
  }

  let measurementOwnedByUser = false;
  if (cartItem.sizeType === 'regular' || cartItem.measurementIsBodyMeasurement) {
    measurementOwnedByUser = true;
  } else if ( cartItem.sizeType === 'personal'
    && userClothingMeasurementsDict?.[key2]?.[cartItem.measurementCreationDateTime]?.filter((measObj: any) => measObj.updateDateTime === cartItem.measurementUpdateDateTime)?.[0]) {
    let cartItemMeasurement = userClothingMeasurementsDict[key2][cartItem.measurementCreationDateTime]?.filter((measObj: any) => measObj.updateDateTime === cartItem.measurementUpdateDateTime)[0];
    measurementOwnedByUser = (cartItemMeasurement.idType === 'email'
    && cartItemMeasurement.email === userAccount.email)
    || (cartItemMeasurement.idType === 'phoneNumber'
    && cartItemMeasurement.phoneNumber === userAccount.phoneNumber);
  }

  // We set everything as ok for this current iteration
  measurementOwnedByUser = true;

  let sizeText = "Size: ";
  // if (measurementOwnedByUser === false) {
  //   sizeText = "Measurement is not owned by user. Please add to cart with user's measurement";
  // } else {
  if (cartItem.variantId) {
    // Terbebas generic variant item — show the variant title (or nothing
    // for option-less "Default Title" products).
    sizeText = cartItem.variantTitle && cartItem.variantTitle !== 'Default Title'
      ? "Varian: " + cartItem.variantTitle
      : "";
  } else if (cartItem.sizeType === 'personal') {
    try {
      if (cartItem.measurementIsBodyMeasurement) {
        // USE LATEST INSTEAD OF CORRECT VERSION
        // sizeText = sizeText + userBodyMeasurementsDict[cartItem.measurementCreationDateTime]?.filter((measObj: any) => measObj.updateDateTime === cartItem.measurementUpdateDateTime)?.[0]?.measurementName;
        sizeText = sizeText + userBodyMeasurementsDict[cartItem.measurementCreationDateTime]?.[0]?.measurementName;
      } else {
        sizeText = sizeText + userClothingMeasurementsDict[key2][cartItem.measurementCreationDateTime]?.filter((measObj: any) => measObj.updateDateTime === cartItem.measurementUpdateDateTime)?.[0]?.measurementName;
      }
    } catch (error) {
      if ((cartItem as any)?.userMeasurementsForItem?.measurementName) {
        sizeText = sizeText + (cartItem as any).userMeasurementsForItem.measurementName;
      } else {
        sizeText = sizeText + "Loading..";
      }
    }
  } else {
    sizeText = sizeText + cartItem.regularSize;
  }
  // }

  const clothingType = productDetail.clothingType;
  const fitType = cartItem.fitType;

  var addItemInput = {
    productId: cartItem.productId,
    productDetail: productDetail,
    fitType: cartItem.fitType,
    sizeType: cartItem.sizeType,
    measurementCreationDateTime: cartItem.measurementCreationDateTime,
    measurementUpdateDateTime: cartItem.measurementUpdateDateTime,
    measurementIsBodyMeasurement: cartItem.measurementIsBodyMeasurement,
    regularSize: cartItem.regularSize,
    variantId: cartItem.variantId,
    variantTitle: cartItem.variantTitle,
    unitPrice: cartItem.unitPrice,
    compareAtPrice: cartItem.compareAtPrice,
  }

  var cartStateItem: CartStateItem = {
    productId: cartItem.productId,
    amount: 1,
    clothingType: productDetail.clothingType,
    fitType: cartItem.fitType,
    sizeType: cartItem.sizeType, // "personal" or "regular"
    measurementCreationDateTime: cartItem.measurementCreationDateTime,
    measurementUpdateDateTime: cartItem.measurementUpdateDateTime,
    measurementIsBodyMeasurement: cartItem.measurementIsBodyMeasurement,
    regularSize: cartItem.regularSize,
    ...(cartItem.variantId !== undefined ? {
      variantId: cartItem.variantId,
      variantTitle: cartItem.variantTitle,
      unitPrice: cartItem.unitPrice,
      compareAtPrice: cartItem.compareAtPrice,
    } : {}),
  }

  // Check out if we can add item count
  var hashCartStateItem = hash(cartStateItem);

  if (cart.canAddItemDict[hashCartStateItem] === undefined) {
    dispatch(postCanAddItemCount(cartStateItem));
  }
  // BUNDLING
  const bundlingKeyAmountDict = GetBundlingKeyAmountDict(cart.cartProductList, productsList);

  // Equals to -1 if not exist
  let defaultDiscPrice = productDetail.discountedPrice === undefined ? -1 : productDetail.discountedPrice;

  // BUNDLING PRICE EFFECT
  let bundlingMarker = false;
  if (productDetail?.bundlingData) {
    const bundlingData = productDetail.bundlingData;
    const bundlingKey = bundlingData?.bundlingKey;
    if (bundlingKey && bundlingKeyAmountDict[bundlingKey] > 1) {
      bundlingMarker = true;
      defaultDiscPrice = 
        bundlingKeyAmountDict[bundlingKey] >= 3 ? bundlingData.bundlingPrice3 :
        bundlingKeyAmountDict[bundlingKey] >= 2 ? bundlingData.bundlingPrice2 :
        defaultDiscPrice;
    }
  }

  let combinedProductSpotlightList: ProductSpotlight[] = (cart?.productSpotlightList?.length ? cart.productSpotlightList : []).concat(cart.coupon?.couponProductSpotlightList?.map((prodObj) => ({
    ...prodObj,
    timestampStart: '1999-10-10T00:00:00.000Z',
    timestampLimit: cart.coupon?.expirationDateTime ?? '1999-10-10T00:00:00.000Z', 
    isMainSpotlight: false,
    alternativeSource: 'COUPON'
  })) ?? []);
  let activeSpotlightPromo = cart.coupon?.couponBlastingEffects?.length ? {
    discountedPrice: Math.round((1 - cart.coupon?.couponBlastingEffects?.[0].effectValue) * (productDetail.originalPrice)),
    timestampStart: '1999-10-10T00:00:00.000Z',
    timestampLimit: cart.coupon?.expirationDateTime ?? '1999-10-10T00:00:00.000Z', 
    isMainSpotlight: false,
    alternativeSource: 'COUPON'
  } : getDiscountedPriceAndTimestampInProductSpotlightList(combinedProductSpotlightList, cartItem.productId);
  let spotlightDiscPrice = activeSpotlightPromo.discountedPrice;

  // Terbebas variant item: the per-unit price comes from the variant
  // snapshot, overriding product-level pricing/spotlight logic.
  if (cartItem.variantId && cartItem.unitPrice !== undefined) {
    spotlightDiscPrice = -1;
    defaultDiscPrice = cartItem.compareAtPrice ? cartItem.unitPrice : -1;
  }

  let thereIsDiscountedPrice = defaultDiscPrice !== -1 || spotlightDiscPrice !== -1;
  let discountedPrice = spotlightDiscPrice !== -1 ? spotlightDiscPrice : defaultDiscPrice;

  // USED FOR MINIMIZED UK BADAN VIEW
  // USE LATEST INSTEAD OF CORRECT VERSION
  // Personal-size measurement display removed (regular sizing only).

  // Terbebas variant item: strike-through price from the variant snapshot.
  const displayOriginalPrice = (cartItem.variantId && cartItem.unitPrice !== undefined)
    ? (cartItem.compareAtPrice ?? cartItem.unitPrice)
    : productDetail.originalPrice;

  const openMeasDetail = () => {
    // Personal-size measurement detail overlay removed (regular sizing only).
  }

  // BUNDLING 
  // Kalau pakai spotlight markernya jadi false
  bundlingMarker = spotlightDiscPrice !== -1 ? false : bundlingMarker;

  let timestampSpotlight = activeSpotlightPromo.timestampLimit;
  let spotlightSource = activeSpotlightPromo?.alternativeSource ?? "FLASHSALE";
  
  const isPlusSize = CheckIsPlusSize(cartStateItem, userBodyMeasurementsDict, userClothingMeasurementsDict);

  return (
    <Grid container justifyContent="space-between" className={classes.cartContentItem}>
      {
        isModifiable && (new Date().toISOString() < timestampSpotlight) &&
        <Grid item xs={12} style={{display: 'flex', justifyContent: 'center'}}>
          <Box style={{margin: '12px 0px 19px', width: '100%'}}>
            <Countdown
              date={timestampSpotlight}
              renderer={spotlightSource === "COUPON" && cart?.coupon?.couponFullWidthCountdownMedia ? countdownRendererImgFullwidth(cart.coupon.couponFullWidthCountdownMedia) : countdownRendererNoText}
              onComplete={(timeDelta, completedOnStart) => {
                setTimeout(() => {
                  parentRenderCallback(new Date().toISOString());
                  console.log('Rerender harusnya jalan')
                }, 400)
              }}
            />
          </Box>
        </Grid>
      }
      {/* Gambar */}
      <Grid item xs={4} sm={3} className={classes.cartContentImageGridItem}>
        <div className={classes.cartContentImageContainer}>
          <img className={classes.cartContentImage} src={productDetail.displayImage} alt="product img"/>
        </div>
      </Grid>
      {/* Konten */}
      <Grid container item xs={8}>
        <Grid container item xs={12}>
          <Grid item xs={isModifiable ? 8 : 12}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              height: !isModifiable ? '100%' : undefined
            }}
          >
            <div className={classes.cartItemDetails}>
              <div className={classes.cartContentItemName}>
                <Typography className={classes.cartContentItemNameText}>
                  <b>{ReactHtmlParser(productDetail.name)}</b>
                </Typography>
              </div>
              
              <div className={classes.cartContentItemSub}>
                {
                  measurementOwnedByUser ?
                  <Typography className={classes.cartContentItemSubText}>
                    {sizeText}
                  </Typography> :
                  <Typography className={classes.cartContentItemSubTextRed}>
                    {sizeText}
                  </Typography>
                }
                {/* Personal-size DETAIL/EDIT buttons removed (regular sizing only). */}
              </div>
              {
                isModifiable ? 
                <div className={classes.cartContentItemSub}>
                  <Typography className={classes.cartContentItemSubGantiUkuranText} onClick={()=> {
                    dispatch(updateCurrentScreen("DEFAULT")); 
                    history.push("/shop/product/" + cartItem.productId);
                  }}>
                    UBAH UKURAN
                  </Typography>
                </div>:
                null
              }
              {
                isModifiable ? (
                  <div className={classes.cartItemAmountButtonsContainer}>
                    <IconButton
                      color="primary"
                      aria-label="Decrement item count"
                      onClick={() => {
                        dispatch(removeItemCount({
                          productId: cartItem.productId,
                          fitType: cartItem.fitType,
                          sizeType: cartItem.sizeType,
                          measurementCreationDateTime: cartItem.measurementCreationDateTime,
                          measurementUpdateDateTime: cartItem.measurementUpdateDateTime,
                          regularSize: cartItem.regularSize,
                          variantId: cartItem.variantId,
                        }));
                        (window as any).dataLayer.push({'event': 'cartRemoveItemCount', 'productId': "productId-" + cartItem.productId});
                        Mixpanel.track('cartRemoveItemCount', {
                          'productId': "productId-" + cartItem.productId,
                        });
                      }}
                      disabled={!isModifiable || cartItem.amount < 2 || !measurementOwnedByUser}
                      className={classes.cartItemAmountButton}
                    >
                      <Remove fontSize="small" />
                    </IconButton>
                    <div className={classes.cartContentItemAmount}>
                      <Typography className={classes.cartContentItemAmountText}>
                        {cartItem.amount}
                      </Typography>
                    </div>
                    <IconButton
                      aria-label="Increment item count"
                      color="primary"
                      onClick={() => {dispatch(addItemCount(addItemInput));
                      (window as any).dataLayer.push({'event': 'cartAddItemCount', 'productId': "productId-" + cartItem.productId});
                      Mixpanel.track('cartAddItemCount', {
                        'productId': "productId-" + cartItem.productId,
                      });
                    }}
                      disabled={canAddProductAmountToCart(cart, cartStateItem) !== "ENOUGH" || !isModifiable || !measurementOwnedByUser}
                      className={classes.cartItemAmountButton}
                    >
                      <Add fontSize="small" />
                    </IconButton>
                  </div>
                ) :
                (
                  null
                )
              }
            </div>
          </div>
          </Grid>
          {
            isModifiable ? (
              <Grid item xs={4} 
                className={classes.removeAndPriceContainer}
              >
                <IconButton
                  edge="end"
                  aria-label="Remove item"
                  color="primary"
                  onClick={() => {dispatch(removeItem({ 
                      productId: cartItem.productId,
                      fitType: cartItem.fitType,
                      sizeType: cartItem.sizeType,
                      measurementCreationDateTime: cartItem.measurementCreationDateTime,
                      measurementUpdateDateTime: cartItem.measurementUpdateDateTime,
                      regularSize: cartItem.regularSize,
                      variantId: cartItem.variantId,
                    }));
                    (window as any).dataLayer.push({'event': 'cartRemoveItem', 'productId': "productId-" + cartItem.productId});
                    Mixpanel.track('cartRemoveItem', {
                      'productId': "productId-" + cartItem.productId,
                    });
                  }}
                  disabled={!isModifiable}
                  className={classes.removeItemButton}
                  size="small"
                >
                  <Close fontSize="small" />
                </IconButton>
                <div>
                  {
                    hideDiscountedPrice ? 
                    <Typography className={classes.itemPrice} >
                      {"Rp " + displayOriginalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </Typography>:
                    cartItemsWithCouponPromotions?.[cartItem?.productId]?.amountDiscounted && thereIsDiscountedPrice ?
                    <Typography className={classes.itemPrice} >
                      <span className={classes.itemStrikePriceRed}>
                        { "Rp " + displayOriginalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        <br></br>
                      </span>
                      <span className={classes.itemStrikePriceRed}>
                        { "Rp " + discountedPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        <br></br>
                      </span>
                      <span>
                      { "Rp " + cartItemsWithCouponPromotions[cartItem.productId].discountedPriceWithCouponPromotions.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </span>
                    </Typography>:
                    cartItemsWithCouponPromotions?.[cartItem?.productId]?.amountDiscounted && !thereIsDiscountedPrice ?
                    <Typography className={classes.itemPrice} >
                      <span className={classes.itemStrikePriceRed}>
                        { "Rp " + displayOriginalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        <br></br>
                      </span>
                      <span>
                      { "Rp " + cartItemsWithCouponPromotions[cartItem.productId].discountedPriceWithCouponPromotions.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </span>
                    </Typography>:
                    thereIsDiscountedPrice ?
                    <Typography className={classes.itemPrice} >
                      <span className={classes.itemStrikePriceRed}>
                        { "Rp " + displayOriginalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        <br></br>
                      </span>
                      { "Rp " + discountedPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </Typography>:
                    <Typography className={classes.itemPrice} >
                      { "Rp " + displayOriginalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </Typography>
                  }
                  {
                    cartItemsWithCouponPromotions?.[cartItem?.productId]?.amountDiscounted &&
                    cart.coupon?.expirationDateTime &&
                    (new Date().toISOString() < cart.coupon.expirationDateTime) &&
                    <Box style={{margin: '2px 0px 7px'}}>
                      <Countdown
                        date={cart.coupon.expirationDateTime}
                        renderer={countdownRendererNoText}
                        onComplete={(timeDelta, completedOnStart) => {
                          setTimeout(() => {
                            parentRenderCallback(new Date().toISOString());
                            console.log('Rerender harusnya jalan')
                          }, 400)
                        }}
                      />
                    </Box>
                  }
                </div>
              </Grid>
            ) : (
              null
            )
          }
        </Grid>
        <Grid item xs={12}>
        {
          !isModifiable ? (
            <div
            className={classes.cartItemDetails}
            style={{
              flexDirection: 'row',
              alignItems: 'flex-end',
              justifyContent: 'space-between',
            }}
          >
            <div
              style={{
                display: 'flex',
                gap: '7.5px',
                padding: '6px 10px 2.5px 10px',
                border: 'solid',
                borderWidth: '1px',
                borderColor: '#D5D6D7',
                borderRadius: 20,
              }}
            >
              <Typography 
                className={classes.itemPrice}
                style={{fontWeight: 500, fontFamily: 'OakesGrotesk', paddingBottom: 0, letterSpacing: '1px'}}
              >
                QTY
              </Typography>
              <Typography 
                className={classes.itemPrice}
                style={{fontWeight: 500, fontFamily: 'OakesGrotesk', paddingBottom: 0, letterSpacing: '1px'}}
              >
                {cartItem.amount}
              </Typography>
            </div>
            <div>
              {
                hideDiscountedPrice ? 
                <Typography className={classes.itemPrice} >
                  {"Rp " + displayOriginalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </Typography>:
                cartItemsWithCouponPromotions?.[cartItem?.productId]?.amountDiscounted && thereIsDiscountedPrice ?
                <Typography className={classes.itemPrice} >
                  <span className={classes.itemStrikePrice}>
                    { "Rp " + displayOriginalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    <br></br>
                  </span>
                  <span className={classes.itemStrikePrice}>
                    { "Rp " + (productDetail.discountedPrice !== -1 ? productDetail.discountedPrice : discountedPrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    <br></br>
                  </span>
                  <span style={{color: 'green'}}>
                  { "Rp " + cartItemsWithCouponPromotions[cartItem.productId].discountedPriceWithCouponPromotions.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </span>
                </Typography>:
                cartItemsWithCouponPromotions?.[cartItem?.productId]?.amountDiscounted && !thereIsDiscountedPrice ?
                <Typography className={classes.itemPrice} >
                  <span className={classes.itemStrikePrice}>
                    { "Rp " + displayOriginalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    <br></br>
                  </span>
                  <span style={{color: 'green'}}>
                  { "Rp " + cartItemsWithCouponPromotions[cartItem.productId].discountedPriceWithCouponPromotions.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </span>
                </Typography>:
                thereIsDiscountedPrice ?
                <Typography className={classes.itemPrice} >
                  <span className={classes.itemStrikePrice}>
                    { "Rp " + displayOriginalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    <br></br>
                  </span>
                  { "Rp " + (productDetail.discountedPrice !== -1 ? productDetail.discountedPrice : discountedPrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </Typography>:
                <Typography className={classes.itemPrice} >
                  { "Rp " + displayOriginalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </Typography>
              }
            </div>
          </div>
          ) : (
            null
          )
        }
        </Grid>
      </Grid>
      {/* Bundling */}
      {
        bundlingMarker ?
        <Grid item xs={12} style={{display: 'flex', justifyContent: 'flex-end'}}>
          <Typography style={{
            fontSize: '8px',
            fontWeight: 600,
            padding: '3px 7px 1px',
            borderRadius: '150px',
            border: '1px solid rgb(195, 195, 195)',
            color: '#121212',
            height: 'fit-content',
            alignSelf: 'anchor-center',
            letterSpacing: '0.3px',
          }}>
            HARGA BUNDLING <span style={{fontSize: '7.4px', paddingLeft: '2px'}}>✅</span>
          </Typography>
        </Grid>:
        null
      }
      {/* Plus Size Extra Charge */}
      {
        isPlusSize &&
        <Grid item xs={12} style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '5px 12px',
          marginTop: '8px',
          border: '1px solid rgb(194,194,194)',
          borderRadius: '30px'
        }}>
          <Box style={{display: 'flex', alignItems: 'center'}}>
            <Typography style={{
              fontSize: '8px',
              padding: '2px 6px 0px',
              marginRight: '7px',
              border: '1px solid rgb(6, 37, 158)',
              borderRadius: '40px',
              color: 'rgb(6, 37, 158)',
              height: 'fit-content'
            }}>PLUS</Typography>
            <Typography style={{
              fontSize: '12px',
              marginRight: '5px',
              paddingTop: '2px',
              fontWeight: 500,
            }}>
              Plus Size
            </Typography>
          </Box>
          <Typography style={{
            fontSize: '11px',
            fontWeight: 300,
            color: '#232323',
            paddingTop: '2px',
          }}>
            + Rp {(productDetail?.extraSizeChargePrice ?? 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Typography>
        </Grid>
      }

      {/* Edit Label Nama */}
      {
        labelNamaManualArray && startIndex !== undefined && setLabelNamaDialogOpen && setSelectedLabelNama &&
        <Grid item xs={12} className={classes.editLabelContent}>
          <Box className={classes.labelHeader}>
            <Typography style={{ color: '#1c1c1cff', fontWeight: 700, fontSize: '14px', textAlign: 'left' }}>
              LABEL NAMA
            </Typography>

            {
              changeLabelNamaDeadline && !labelExpired ? (
                <Box className={classes.timerBox}>
                  <Typography className={classes.countdown}>
                    <Countdown
                      date={new Date(changeLabelNamaDeadline).getTime()}
                      renderer={({ minutes, seconds, completed }) =>
                        completed ? "00:00" : `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
                      }
                      onComplete={() => setLabelExpired(true)}
                    />
                  </Typography>
                  <Typography className={classes.keteranganTimer}>
                    Ubah nama sebelum jam{" "}
                    {new Date(changeLabelNamaDeadline).toLocaleTimeString("id-ID", {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </Typography>
                </Box>
              ) : (
                <Box>
                  <Typography className={classes.keteranganWaktuHabis}>
                    <i>Waktu pengaturan label habis.</i>
                  </Typography>
                  <Typography className={classes.keteranganWaktuHabis}>
                    <i>Atur lagi pada <span style={{textDecoration: 'underline', textUnderlineOffset: '2px'}}>pesanan berikutnya.</span></i>
                  </Typography>
                </Box>
              )
            }
          </Box>

          <Grid container spacing={1} className={classes.gridLabelContainer} wrap="wrap">
            {labelNamaManualArray.slice(startIndex, startIndex + cartItem.amount).map((label, i) => (
              <Grid item xs={6} key={startIndex + i} >
                <Box className={classes.labelItem}>
                  <img src='https://studiosclo.uk/legacy/sur_monogram_minimum.svg' width={18} style={{filter: 'invert(100%)'}} />
                  {
                    label === "" ? (
                      <Typography style={{ fontSize: '9px', textAlign: 'center', marginLeft: 'auto', marginRight: 'auto' }}>
                        <i>Label nama belum dipilih</i>
                      </Typography>
                    ) : (
                      <Typography className={classes.labelName} style={{ marginLeft: 'auto', marginRight: 'auto' }}>
                        {label}
                      </Typography>
                    )
                  }
                  
                  {changeLabelNamaDeadline && !labelExpired ? (
                    <IconButton
                      style={{ padding: "0px" }}
                      onClick={() => {
                        setSelectedLabelNama(startIndex + i);
                        setLabelNamaDialogOpen(true);
                      }}
                    >
                      <BorderColorIcon style={{ fontSize: "15px", color: 'white' }} />
                    </IconButton>
                  ) : null}
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>
      }
    </Grid>
  );
}

export function CartContentItemMeaskit({isModifiable}: {isModifiable: boolean}) {
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const history = useHistory();

  return (
    <Grid container justifyContent="space-between" className={classes.cartContentItem}>
      {/* Gambar */}
      <Grid item xs={4} sm={3} className={classes.cartContentImageGridItem}>
        <div className={classes.cartContentImageContainer}>
          <img className={classes.cartContentImage} src={'https://studiosclo.uk/general/web-general-measkit-1.jpg'} alt="product img"/>
        </div>
      </Grid>
      {/* Konten */}
      <Grid container item xs={8}>
        <Grid container item xs={12}>
          <Grid item xs={isModifiable ? 8 : 12}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              height: !isModifiable ? '100%' : undefined
            }}
          >
            <div className={classes.cartItemDetails}>
              <div className={classes.cartContentItemName}>
                <Typography className={classes.cartContentItemNameText} style={{marginBottom: '-3px'}}>
                  <b>{ReactHtmlParser('Personal Measurement Kit<sup>TM</sup>')}</b>
                </Typography>
              </div>
              <div className={classes.cartContentItemSub}>
                <Typography className={classes.cartContentItemSubText} style={{fontSize: '10px', marginBottom: '1px'}}>
                  {"Didapatkan di setiap pembelian pertama."}
                </Typography>
              </div>
              {
                isModifiable ? 
                <div className={classes.cartContentItemSub}>
                  <Typography className={classes.cartContentItemSubGantiUkuranText}>
                    MULAI JOURNEY KAMU
                  </Typography>
                </div>:
                null
              }
              {
                isModifiable ? (
                  <div className={classes.cartItemAmountButtonsContainer}>
                    <IconButton
                      color="primary"
                      aria-label="Decrement item count"
                      disabled={true}
                      className={classes.cartItemAmountButton}
                    >
                      <Remove fontSize="small" />
                    </IconButton>
                    <div className={classes.cartContentItemAmount}>
                      <Typography className={classes.cartContentItemAmountText}>
                        1
                      </Typography>
                    </div>
                    <IconButton
                      aria-label="Increment item count"
                      color="primary"
                      disabled={true}
                      className={classes.cartItemAmountButton}
                    >
                      <Add fontSize="small" />
                    </IconButton>
                  </div>
                ) :
                (
                  null
                )
              }
            </div>
          </div>
          </Grid>
          {
            isModifiable ? (
              <Grid item xs={4} 
                className={classes.removeAndPriceContainer}
              >
                <IconButton
                  edge="end"
                  aria-label="Remove item"
                  color="primary"
                  disabled={true}
                  className={classes.removeItemButton}
                  size="small"
                >
                  <Close fontSize="small" />
                </IconButton>
                <div>
                  <Typography className={classes.itemPrice} >
                    <span className={classes.itemStrikePriceRed}>
                      { "Rp " + (15000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      <br></br>
                    </span>
                    <b>FREE</b>
                  </Typography>
                </div>
              </Grid>
            ) : (
              null
            )
          }
        </Grid>
        <Grid item xs={12}>
        {
          !isModifiable ? (
            <div
            className={classes.cartItemDetails}
            style={{
              flexDirection: 'row',
              alignItems: 'flex-end',
              justifyContent: 'space-between',
            }}
          >
            <div
              style={{
                display: 'flex',
                gap: '7.5px',
                padding: '6px 10px 2.5px 10px',
                border: 'solid',
                borderWidth: '1px',
                borderColor: '#D5D6D7',
                borderRadius: 20,
              }}
            >
              <Typography 
                className={classes.itemPrice}
                style={{fontWeight: 500, fontFamily: 'OakesGrotesk', paddingBottom: 0, letterSpacing: '1px'}}
              >
                QTY
              </Typography>
              <Typography 
                className={classes.itemPrice}
                style={{fontWeight: 500, fontFamily: 'OakesGrotesk', paddingBottom: 0, letterSpacing: '1px'}}
              >
                {1}
              </Typography>
            </div>
            <div>
              <Typography className={classes.itemPrice}>
                <span className={classes.itemStrikePrice}>
                  { "Rp " + (15000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  <br></br>
                </span>
                {"FREE"}
              </Typography>
            </div>
          </div>
          ) : (
            null
          )
        }
        </Grid>
      </Grid>
    </Grid>
  );
}

export default CartContentItem;